"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Name = exports.AddFreeShippingOfferEvent = void 0;
const Name = exports.Name = 'add-free-shipping-offer';
const AddFreeShippingOfferEvent = exports.AddFreeShippingOfferEvent = Name;
//# sourceMappingURL=index.js.map